import { Modules } from '../../../util/modules'
import { ProductRouteNames } from '@/routes/constants/location'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const ProductCollections = () =>
    import('@/pmd/pages/payments/products/ProductCollections.vue')
  const CreateProducts = () =>
    import('@/pmd/pages/payments/products/CreateProducts.vue')
  const BulkEditProducts = () =>
    import('@/pmd/pages/payments/products/BulkEditProducts.vue')
  const ImportStripe = () =>
    import('@/pmd/pages/payments/products/ImportStripe.vue')
  const ListProducts = () =>
    import('@/pmd/pages/payments/products/ListProducts.vue')
  const ProductReviews = () =>
    import('@/pmd/pages/payments/products/ProductReviews.vue')
  const ProductVariants = () =>
    import('@/pmd/pages/payments/products/ProductVariants.vue')
  const ViewProducts = () =>
    import('@/pmd/pages/payments/products/ViewProducts.vue')

  export const ProductRoute: RouteConfig[] = [
    {
        path: 'payments/products/collections',
        name: ProductRouteNames.collections,
        component: ProductCollections,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'payments/products/reviews',
        name: ProductRouteNames.reviews,
        component: ProductReviews,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },

      {
        path: 'payments/products',
        name: ProductRouteNames.products,
        component: ListProducts,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'payments/products/create',
        name: ProductRouteNames.create,
        component: CreateProducts,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: true,
          translations: [Modules.Payments]
        },
      },

      {
        path: 'payments/products/view/:id',
        name: ProductRouteNames.details,
        component: ViewProducts,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },

      {
        path: 'payments/products/edit/:id',
        name: ProductRouteNames.edit,
        component: CreateProducts,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: true,
          translations: [Modules.Payments]
        },
      },

      {
        path: 'payments/products/stripe/import',
        name: ProductRouteNames.stripe,
        component: ImportStripe,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      
      {
        path: 'payments/products/:productId/variants/:priceId',
        name: ProductRouteNames.viewVariants,
        component: ProductVariants,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'payments/products/bulk-edit',
        name: ProductRouteNames.bulkEdit,
        component: BulkEditProducts,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: true,
          hideSideBar: true,
          translations: [Modules.Payments]
        },
      },
  ]